<template>
    <div id="app">
        <div class="nav">
            <a href="http://blog.alibt.top" target="_blank" class="blog">Blog</a>
            <router-link to="/">Home</router-link>
            <router-link to="date-picker">日历</router-link>
            <router-link to="location">省市选择</router-link>
            <router-link to="schedule">时段选择</router-link>
            <router-link to="draggable">拖放排序</router-link>
            <a href="https://github.com/cyyjs/cvc" target="_blank" class="github">
                <svg aria-hidden="true" class="octicon octicon-mark-github" height="24" version="1.1" viewBox="0 0 16 16" width="24"><path fill-rule="evenodd" fill="#fff" d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 16 8c0-4.42-3.58-8-8-8z"></path></svg>
            </a>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name: 'app'
}
</script>
<style lang='scss'>
body {
    padding: 0;
    margin: 0;
}
.blog{
    float: left;
    line-height: 25px;
    margin-left: 20px;
}
.github{
    float: right;
    margin-right: 20px;
    height: 25px;
}
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

.nav {
    line-height: 45px;
    background: cadetblue;
    & a {
        padding: 10px;
        color: #fff;
        text-decoration: none;
        &:hover {
            border-bottom: 3px solid #20a0ff;
            background-color: #6db39f;
        }
    }
}

.box {
    display: flex;
    justify-content: center;
}

.ml20 {
    margin-left: 20px;
}

pre {
    text-align: left;
    margin: auto;
    max-height: 350px;
    overflow: auto;
}
</style>



// WEBPACK FOOTER //
// App.vue?6b8a4b2c